export const REGEX: { [key:string]: RegExp} = {
    ALPHANUMERIC:  /^[a-zA-Z0-9]*$/,
    LAST_NAME: /^[a-zA-Z' ]+$/,
    ZIP_CODE: /^(?:\d{5}(-\d{4})?|\d{9})$/
}
